var _effectorFileName = "/src/page-content/payment/components/payment-form/schema.ts";
import { z } from 'zod';
import { EMAIL_NOT_VALID_MESSAGE, MAX_LENGTH_MESSAGE, MIN_LENGTH_MESSAGE, REQUIRED_FIELD_MESSAGE } from '@/shared/constants/error-messages';
export const paymentFormSchema = z.object({
  serviceCategory: z.string(),
  service: z.object({
    lessonPrice: z.string().min(1, {
      message: REQUIRED_FIELD_MESSAGE
    }),
    lessonType: z.string().min(1, {
      message: REQUIRED_FIELD_MESSAGE
    })
  }).refine(() => true, {
    message: REQUIRED_FIELD_MESSAGE,
    path: ['lessonPrice', 'lessonType']
  }),
  teacher: z.object({
    name: z.string().min(1, {
      message: REQUIRED_FIELD_MESSAGE
    }),
    surname: z.string(),
    patronymicName: z.string(),
    taxNumber: z.string(),
    tel: z.string()
  }).refine(() => true, {
    message: REQUIRED_FIELD_MESSAGE,
    path: ['name', 'surname', 'patronymicName', 'taxNumber', 'tel']
  }),
  client: z.object({
    name: z.string().min(2, {
      message: MIN_LENGTH_MESSAGE
    }).max(250, {
      message: MAX_LENGTH_MESSAGE
    }).trim().toLowerCase().refine(value => !!value, {
      message: REQUIRED_FIELD_MESSAGE,
      path: []
    }),
    surname: z.string().min(2, {
      message: MIN_LENGTH_MESSAGE
    }).max(250, {
      message: MAX_LENGTH_MESSAGE
    }).trim().toLowerCase().refine(value => !!value, {
      message: REQUIRED_FIELD_MESSAGE,
      path: []
    }),
    email: z.string().email({
      message: EMAIL_NOT_VALID_MESSAGE
    }).refine(value => !!value, {
      message: REQUIRED_FIELD_MESSAGE,
      path: []
    })
  }).refine(() => true, {
    message: REQUIRED_FIELD_MESSAGE,
    path: ['name', 'surname', 'email']
  }),
  terms: z.object({
    isAgreeWithPublicOffer: z.boolean().refine(value => value, {
      message: 'Вам нужно согласиться с уловиями, чтобы продолжить'
    }),
    isAgreeWithPaymentRules: z.boolean().refine(value => value, {
      message: 'Вам нужно согласиться с правилами оплаты, чтобы продолжить'
    }),
    isAgreeWithPersonalDataProcessing: z.boolean().refine(value => value, {
      message: 'Вам нужно согласиться с обработкой персональных данных, чтобы продолжить'
    }),
    isPromocodeAccepted: z.boolean().or(z.null()),
    isForeignCard: z.boolean()
  })
});